import { useState } from 'react';

const STORAGE_KEY = 'scriptvoice.welcome-dismissed';

export function WelcomeBanner({ visible }: { visible: boolean }) {
  const initial = typeof window !== 'undefined' && localStorage.getItem(STORAGE_KEY) === '1';
  const [dismissed, setDismissed] = useState(initial);

  if (!visible || dismissed) return null;

  return (
    <div className="border border-accent/30 bg-accent/5 rounded-lg p-5 mb-6 relative">
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => {
          localStorage.setItem(STORAGE_KEY, '1');
          setDismissed(true);
        }}
        className="absolute top-2 right-3 text-muted/60 hover:text-muted text-lg leading-none"
      >
        ×
      </button>
      <h2 className="font-serif text-xl mb-2">Welcome to Scriptvoice</h2>
      <p className="text-sm text-muted mb-3">
        We seeded a sample project for you. Open it to see what a directed script looks like.
        You'll find three things to play with:
      </p>
      <ul className="text-sm text-muted space-y-1.5 list-disc pl-5 mb-3">
        <li><span className="text-ink">Cue chips</span> — click any highlighted phrase to swap its tone.</li>
        <li><span className="text-ink">Section re-direct</span> — the ⋯ menu next to each section regenerates it with a new tone.</li>
        <li><span className="text-ink">Render</span> — pick a voice in Settings, then hit Render to hear the result.</li>
      </ul>
      <p className="text-xs text-muted/70">
        You'll need a TTS API key (ElevenLabs, Cartesia, OpenAI, Gemini, or Azure) in Settings to render.
      </p>
    </div>
  );
}
